export default  {
  'processing': '@:terms.issue중',
  'completed': '@:terms.issue@:terms.complete',
}
